import Swiper from 'swiper';

export default class SliderFs {
  constructor() {
    window.addEventListener('load', () => {
      this.setup();
    });
  }
  setup() {
    const supportOptions = {
      freeMode: true,
      slidesPerView: 3.5,
      spaceBetween: 8,
      navigation: {
        nextEl: '.c-supportSlider__next',
        prevEl: '.c-supportSlider__prev'
      },
      scrollbar: {
        el: '.c-supportSlider__scrollbar',
        hide: false
      },
      breakpoints: {
        1199.98: {
          slidesPerView: 3
        },
        767.98: {
          slidesPerView: 2.4,
          spaceBetween: 8
        }
      }
    };
    const serviceOptions = {
      freeMode: true,
      slidesPerView: 3.5,
      spaceBetween: 8,
      navigation: {
        nextEl: '.c-serviceSlider__next',
        prevEl: '.c-serviceSlider__prev'
      },
      scrollbar: {
        el: '.c-serviceSlider__scrollbar',
        hide: false
      },
      breakpoints: {
        1199.98: {
          slidesPerView: 3
        },
        767.98: {
          slidesPerView: 2,
          spaceBetween: 8
        }
      }
    };
    const calenderOptions = {
      slidesPerView: 3,
      spaceBetween: 24,
      followFinger: false,
      navigation: {
        nextEl: '.c-calendarSlider__next',
        prevEl: '.c-calendarSlider__prev'
      },
      breakpoints: {
        991.98: {
          slidesPerView: 2,
          followFinger: true
        },
        767.98: {
          slidesPerView: 1,
          spaceBetween: 8,
          followFinger: true,
          pagination: {
            el: '.c-calendarSlider__pagination',
            clickable: true,
            type: 'bullets'
          }
        }
      }
    };
    const dealerOptions = {
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: '.c-dealerSlider__pagination',
        clickable: true,
        type: 'bullets'
      }
    };

    new Swiper('.js-supportSlider', supportOptions);
    new Swiper('.js-serviceSlider', serviceOptions);
    const calendarSlider = new Swiper('.js-calendarSlider', calenderOptions);

    const dealerSliderLength = document.querySelectorAll('.js-dealerSlider .swiper-slide').length;
    if (dealerSliderLength > 1) {
      new Swiper('.js-dealerSlider', dealerOptions);
    }

    $('#calendarModal').on('shown.bs.modal', function() {
      calendarSlider.update();
    });
  }
}
